import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import PassportPhotoMakerComponent from './Components/PassportPhotoMaker.vue';

const app = createApp({
    components: {
        PassportPhotoMakerComponent

    },

});
app.mount('#app');

